import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@devhop/ui";

export function SendConfirmDialog({
  open,
  count,
  submitting,
  onConfirm,
  onOpenChange,
}: {
  open: boolean;
  count: number;
  submitting?: boolean;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
}) {
  const estimatedSeconds = Math.max(10, count * 10);

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>ຢືນຢັນສົ່ງ WhatsApp</AlertDialogTitle>
          <AlertDialogDescription>
            ສົ່ງ {count} ຂໍ້ຄວາມຜ່ານ WhatsApp Studio — ປະມານ{" "}
            {estimatedSeconds} ວິນາທີ
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={submitting}>ຍົກເລີກ</AlertDialogCancel>
          <AlertDialogAction disabled={submitting || count === 0} onClick={onConfirm}>
            {submitting ? "ກຳລັງສົ່ງ..." : "ສົ່ງ WhatsApp"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
